import cookie from 'react-cookies';
import Amplify, {Auth} from 'aws-amplify';
import awsconfig from '../../backendConfigProvider';
Amplify.configure(awsconfig);

// returns student_id from auth session / cookie
const getSessionStudentId = async () => {
  let currentAuthUser;
  try {
    currentAuthUser = await Auth.currentAuthenticatedUser();
  } catch (error) {
    // ignore
  }
  const studentId = currentAuthUser?.attributes['custom:student_id'] ||
     cookie.load('student_id');
  return studentId;
};

export const ctaClickAction = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'cta-click-action',
      'cta-click-param': params,
    });
  }, 50);
};

export const lessonClickAction = (params) => {
  setTimeout(() => {
    window?.dataLayer?.push({
      'event': 'lesson-click-action',
      'lesson-click-param': params,
    });
  }, 50);
};

export const lessonEarly = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'lesson-early-action',
      'lesson-early-param': params,
    });
  }, 50);
};

export const lessonOnTime = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'lesson-ontime-action',
      'lesson-ontime-param': params,
    });
  }, 50);
};

export const trackWebinarAttendance = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'track-action',
      'event-param': {
        'event': 'webinar_attendance',
        'parameter': params,
      },
    });
  }, 50);
};

export const trackLtvFetchFailed = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'track-action',
      'event-param': {
        'event': 'ltv-fetch-failed',
        'parameter': params,
      },
    });
  }, 50);
};

export const popUpAction = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'popup-action',
      'popup-param': params,
    });
  }, 50);
};

export const assignmentClickAction = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'assessment-click-action',
      'assessment-click-param': params,
    });
  }, 50);
};

export const assignmentCompleteAction = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'assessment-complete-action',
      'assessment-complete-param': params,
    });
  }, 50);
};

export const trackAddonPurchaseAction = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'addon-purchase-action',
      'event-param': params,
    });
  }, 50);
};

export const webinarRatingEvent = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'lesson-rate-action',
      'lesson-rate-param': params,
    });
  }, 50);
};

export const profileCompleteAction = (profileParam) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'profile-complete-action',
      'profile-param': profileParam,
    });
  }, 50);
};

export const pageViewActionAllParams = (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'view-page-action',
      'view-page-param': params,
    });
  }, 50);
};

export const downloadClickAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'download-click-action',
    'download-click-param': {
      'studentId': studentId,
      ...params,
    },
  });
};

export const triggerApiErrorAction = (pageKind, status) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'api-error-action',
      'api-error-param': {
        'pageKind': pageKind,
        'status': status,
      },
    });
  }, 0);
};

export const apiErrorAction = (pageKind, apiUrl, status) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'api-error-action',
      'api-error-param': {
        'pageKind': pageKind,
        'status': status,
        'api': apiUrl,
      },
    });
  }, 0);
};


export const loggedInAction = (locale) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'logged-in-action',
      'logged-in-param': {
        'locale': locale,
      },
    });
  }, 50);
};

export const registrationAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'registration-action',
    'registration-param': {
      'studentId': studentId,
      'action': 'Rescheduled',
      'moduleNumber': params.moduleNumber,
      'courseSlug': params.courseSlug,
      'facultySlug': params.facultySlug,
      'locale': params.locale,
      'lessonNumber': params.lessonNumber || null,
      'rescheduleType': params.rescheduleType ? params.rescheduleType :
          null,
    },
  });
};

export const lessonRegistrationAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'registration-action',
    'registration-param': {
      'studentId': studentId,
      'action': 'Rescheduled',
      'moduleNumber': params.moduleNumber,
      'courseSlug': params.courseSlug,
      'facultySlug': params.facultySlug,
      'locale': params.locale,
      'Goal': params.Goal,
      'rescheduleType': params.rescheduleType ? params.rescheduleType :
          null,
    },
  });
};

export const registerModuleAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'registration-action',
    'registration-param': {
      'studentId': studentId,
      'action': 'RegisteredModule',
      'moduleNumber': params.moduleNumber,
      'courseSlug': params.courseSlug,
      'facultySlug': params.facultySlug,
      'locale': params.locale,
      'Goal': params.Goal,
    },
  });
};

export const registrationModuleAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'registration-action',
    'registration-param': {
      'studentId': studentId,
      'action': 'RegisteredModule',
      'moduleNumber': params.moduleNumber,
      'courseSlug': params.courseSlug,
      'facultySlug': params.facultySlug,
      'locale': params.locale,
    },
  });
};

export const subscriptionChangeAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'subscription-change-action',
    'subscription-change-param': {
      'studentId': studentId,
      'action': params.action,
      'planId': params.planId,
    },
  });
};

export const subscriptionChangeActionWithPageKind = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'subscription-change-action',
    'subscription-change-param': {
      'studentId': studentId,
      'action': params.action,
      'planId': params.planId,
      'pageKind': params.pageKind,
    },
  });
};

export const subscriptionChangeActionAllParams= (params) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'subscription-change-action',
      'subscription-change-param': params,
    });
  }, 50);
};

export const subscriptionChangeCancellationAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'subscription-change-action',
    'subscription-change-param': {
      'studentId': studentId,
      'action': params.action,
      'planId': params.planId,
      'reason1': params.reason1,
      'reason2': params.reason2,
      'reason3': params.reason3,
      'reason4': params.reason4,
      'reason5': params.reason5,
      'reason6': params.reason6,
    },
  });
};

export const cancellationAttemptedAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'cancellation-attempted-action',
    'cancellation-attempted-param': {
      'studentId': studentId || '',
      'stepNumber': params.stepNumber,
      'offering': params.offering,
      'reason': params.reason,
      'behaviourType': params.behaviourType,
      'accountType': params.accountType,
      'daysFromBilling': params.daysFromBilling,
      'moduleCount': params.moduleCount,
    },
  });
};
export const cancellationOutcomeAction = async (params) => {
  const studentId = await getSessionStudentId();
  window.dataLayer.push({
    'event': 'cancellation-outcome-action',
    'cancellation-outcome-param': {
      'outcome': params?.outcome || 'saved',
      'studentId': studentId,
      'stepNumber': params.stepNumber,
      'offering': params.offering,
      'reason': params.reason,
      'behaviourType': params.behaviourType,
      'accountType': params.accountType,
      'daysFromBilling': params.daysFromBilling,
      'moduleCount': params.moduleCount,
    },
  });
};

export const signupAction = (signupParam) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'signup-action',
      'signup-action-event-param': signupParam,
    });
  }, 50);
};

export const returnSignupAction = (signupParam) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'return-signup-action',
      'signup-action-event-param': signupParam,
    });
  }, 50);
};

export const subscriptionTrialAction = (subscriptionParam) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'subscription-trial-action',
      'subscription-event-param': subscriptionParam,
    });
  }, 50);
};

export const cardSubmissionFailedAction = (cardFailedParam) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'card-submission-failed-event',
      'card-submission-failed-param': cardFailedParam,
    });
  }, 50);
};

export const addonPurchaseFailedAction = (addonFailedParam) => {
  setTimeout(() => {
    window.dataLayer.push({
      'event': 'addon-purchase-failed',
      'addon-purchase-failed-param': addonFailedParam,
    });
  }, 50);
};
export const searchEnteredAction = (params) => {
  setTimeout(() => {
    window?.dataLayer?.push({
      'event': 'search-entered-action',
      'search-entered-param': params,
    });
  }, 50);
};
